export class SnDetectionResolution {
  public height: number;

  public width: number;
}
